import { render, staticRenderFns } from "./StockManager.vue?vue&type=template&id=35dbc661&"
import script from "./StockManager.vue?vue&type=script&lang=js&"
export * from "./StockManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports